import UiBreakdown from '../UiBreakdown.vue.js';
import { internalComponentDefinition } from '../../../helpers/component.js';
import { mergeConfiguration } from '../../../helpers/factory.js';

const DEFAULT_COMPONENT_NAME = "fds-ui-breakdown";
const defaultUiBreakdownChartOptions = {
  time: {
    useUTC: false
  },
  chart: {
    styledMode: true,
    type: "pie",
    height: "100%",
    spacing: [0, 0, 0, 0]
  },
  title: {
    text: "",
    useHTML: true,
    floating: true,
    verticalAlign: "middle"
  },
  tooltip: {
    enabled: true,
    formatter() {
      var _a, _b;
      const label = (_b = (_a = this.point.options.custom) == null ? void 0 : _a.label) != null ? _b : "";
      return `${this.point.name}<br>${label}`;
    }
  },
  credits: { enabled: false },
  legend: { enabled: false },
  series: []
};
const defaultUiBreakdownDonutChartOptions = {
  ...defaultUiBreakdownChartOptions,
  plotOptions: {
    pie: {
      shadow: false,
      innerSize: "85%",
      dataLabels: {
        enabled: false
      }
    }
  }
};
const defaultUiBreakdownPieChartOptions = {
  ...defaultUiBreakdownChartOptions,
  plotOptions: {
    pie: {
      shadow: false,
      dataLabels: {
        enabled: false
      }
    }
  }
};
const defaultUiBreakdownStackedBarChartOptions = {
  ...defaultUiBreakdownChartOptions,
  chart: {
    ...defaultUiBreakdownChartOptions.chart,
    type: "bar",
    height: 50
  },
  tooltip: {
    ...defaultUiBreakdownChartOptions.tooltip,
    formatter() {
      var _a, _b;
      return `<b>${this.series.name}</b>: ${(_b = (_a = this.series.options.custom) == null ? void 0 : _a.label) != null ? _b : ""}`;
    }
  },
  legend: { enabled: false },
  xAxis: {
    labels: {
      enabled: false
    },
    visible: false
  },
  yAxis: {
    reversed: true,
    endOnTick: false,
    labels: {
      enabled: false
    },
    title: {
      text: null
    },
    visible: false,
    max: 1
  },
  plotOptions: {
    series: {
      stacking: "normal"
    },
    bar: {
      pointWidth: 20
    }
  },
  series: []
};
const defaultUiBreakdownVerticalBarChartOptions = {
  ...defaultUiBreakdownChartOptions,
  chart: {
    ...defaultUiBreakdownChartOptions.chart,
    type: "column",
    height: 215,
    spacing: [10, 10, 15, 10],
    margin: void 0
  },
  xAxis: {
    type: "category"
  },
  yAxis: {
    gridLineDashStyle: "Dash",
    title: {
      text: null
    }
  },
  series: []
};
const defaultUiBreakdownHorizontalBarChartOptions = {
  ...defaultUiBreakdownChartOptions,
  chart: {
    ...defaultUiBreakdownChartOptions.chart,
    type: "bar",
    height: 215,
    spacing: [10, 10, 15, 10],
    margin: void 0
  },
  xAxis: {
    tickLength: 0,
    labels: {
      enabled: false
    }
  },
  yAxis: {
    lineWidth: 1,
    gridLineDashStyle: "Dash",
    title: {
      text: null
    }
  },
  series: []
};
const defaultUiBreakdownItemChartOptions = {
  ...defaultUiBreakdownChartOptions,
  chart: {
    ...defaultUiBreakdownChartOptions.chart,
    type: "item",
    spacing: [10, 10, 15, 10],
    margin: void 0
  },
  plotOptions: {
    item: {
      layout: "horizontal",
      rows: 10
    }
  },
  series: []
};
const defaultUiBreakdownOptions = {
  chart: {
    donut: (params) => defaultUiBreakdownDonutChartOptions,
    horizontalBar: (params) => defaultUiBreakdownHorizontalBarChartOptions,
    item: (params) => defaultUiBreakdownItemChartOptions,
    pie: (params) => defaultUiBreakdownPieChartOptions,
    stackedBar: (params) => defaultUiBreakdownStackedBarChartOptions,
    verticalBar: (params) => defaultUiBreakdownVerticalBarChartOptions
  }
};
const asBreakdownType = (item) => item;
const defaultUiBreakdownConfiguration = {
  options: {
    componentName: DEFAULT_COMPONENT_NAME
  }
};
const uiBreakdownFactory = (configuration) => {
  var _a, _b, _c, _d;
  const componentName = (_d = (_c = (_a = configuration.options) == null ? void 0 : _a.componentName) != null ? _c : (_b = defaultUiBreakdownConfiguration.options) == null ? void 0 : _b.componentName) != null ? _d : DEFAULT_COMPONENT_NAME;
  const mergedConfiguration = mergeConfiguration(configuration, defaultUiBreakdownConfiguration);
  return internalComponentDefinition(componentName, mergedConfiguration, UiBreakdown);
};
const uiBreakdownPlugin = {
  install(Vue, configuration = defaultUiBreakdownConfiguration) {
    var _a, _b, _c, _d;
    const componentName = (_d = (_c = (_a = configuration.options) == null ? void 0 : _a.componentName) != null ? _c : (_b = defaultUiBreakdownConfiguration.options) == null ? void 0 : _b.componentName) != null ? _d : DEFAULT_COMPONENT_NAME;
    Vue.component(componentName, uiBreakdownFactory(configuration));
  }
};

export { asBreakdownType, defaultUiBreakdownConfiguration, defaultUiBreakdownDonutChartOptions, defaultUiBreakdownHorizontalBarChartOptions, defaultUiBreakdownItemChartOptions, defaultUiBreakdownOptions, defaultUiBreakdownPieChartOptions, defaultUiBreakdownStackedBarChartOptions, defaultUiBreakdownVerticalBarChartOptions, uiBreakdownFactory, uiBreakdownPlugin };
